import lang from '@/utils/lang'
const language = {
  state: {
    language:sessionStorage.getItem("language")
  },

  mutations: {
    SET_LANGUAGE: (state, language) => {
      let key = lang.getKey(language);
      sessionStorage.setItem("language",key)
      state.language = key;
    },
  },

}

export default language
